
import { BlogPost } from '@/types/blog';

export const initialBlogPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Starting Your SaaS Reseller Business: A Complete Guide',
    content: 'This comprehensive guide walks you through the essential steps to launch your SaaS reseller business. From selecting the right products to marketing strategies and customer support, we cover everything you need to know to get started on the right foot.',
    status: 'published',
    category: 'business',
    date: '2025-04-20',
    author: 'Sarah Johnson',
    image: '/assets/5df22fbf-46c0-422b-a964-30ad729c926d.png',
    readTime: '8 min',
    socialShare: true,
    autoScheduled: false
  },
  {
    id: '2',
    title: 'How to Scale Your Referral Program as a Reseller',
    content: 'Learn proven strategies to scale your referral program effectively. This article explores how to incentivize referrals, track performance, and optimize your program for maximum growth and sustainability.',
    status: 'published',
    category: 'marketing',
    date: '2025-04-15',
    author: 'David Chen',
    image: '/assets/74192c5a-ba76-4e08-9c4a-f98e75942d6c.png',
    readTime: '6 min',
    socialShare: true,
    autoScheduled: false
  },
  {
    id: '3',
    title: 'The Future of White-Label Solutions in 2025',
    content: 'Explore the latest trends and innovations in white-label solutions for 2025. We dive into emerging technologies, market predictions, and how you can position your business to take advantage of these developments.',
    status: 'published',
    category: 'trends',
    date: '2025-04-10',
    author: 'Jessica Martinez',
    image: '/assets/843f56a9-ea90-4bfc-9000-a1b7e1408a94.png',
    readTime: '5 min',
    socialShare: false,
    autoScheduled: true
  },
  {
    id: '4',
    title: 'Maximizing Revenue Share: Tactics for SaaS Resellers',
    content: 'Discover actionable tactics to maximize your revenue share as a SaaS reseller. From negotiation strategies with vendors to pricing models and upselling techniques, this guide provides practical advice to boost your bottom line.',
    status: 'draft',
    category: 'business',
    date: '2025-04-28',
    author: 'Sarah Johnson',
    image: '/assets/36c87bd9-7bdf-4413-bf74-70043278eb04.png',
    readTime: '7 min',
    socialShare: true,
    autoScheduled: true
  },
  {
    id: '5',
    title: 'Building Trust with Your SaaS Reseller Clients',
    content: 'Trust is the foundation of any successful client relationship. This article outlines effective approaches to building and maintaining trust with your SaaS clients, including communication best practices, setting realistic expectations, and delivering consistent value.',
    status: 'scheduled',
    category: 'customer',
    date: '2025-04-30',
    author: 'Jessica Martinez',
    image: '/assets/27882381-1d28-4df0-bbb8-2087fd07ba82.png',
    readTime: '6 min',
    socialShare: true,
    autoScheduled: true
  }
];
